export default pathname => {
  if (pathname === '/') {
    return 'home';
  } else if (/^\/jobs/.test(pathname)) {
    return 'search-results';
  }
  return '';
};



/** WEBPACK FOOTER **
 ** ./app/pathnameToPageName.js
 **/